export default {
  addressColor: Styles.color.grey.one,
  ammenityIconFill: Styles.color.grey.one,
  innerAnchorColor: Styles.color.grey.one,
  innerColor: Styles.color.grey.one,
  innerPColor: Styles.color.grey.one,
  innerLineHeight: 'lg',
  modalBackground: Styles.color.white,
  phoneNumberColor: Styles.color.grey.one,
};
